import { ConsentSettings } from 'firebase/analytics'

//assets type
export const vodAssetType = 'VOD'
export const tvAssetType = 'TIVI'
export const cutvAssetType = 'CUTV'

export type Page = 'VOD' | 'HOME' | 'TV' | 'EPG'

export enum assetsTypes {
    TIVI = 'TIVI',
    VOD = 'VOD',
    CUTV = 'CUTV',
}

export const mobileKeyword = 'Mobile'
export const desktopKeyword = 'Desktop'

export const maxContainerWidth = 1919
export const searchQueryLimit = 100
export const minCharSearchLimit = 3

export const weekDays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
]

//debounce
export const debounceSpeedShort = 100
export const debounceSpeedMedium = 200
export const debounceSpeedLong = 500
export const debounceSpeed1000 = 1000
export const debounceSpeed2000 = 2000

//Settings page
export const settingsPagePath = '/settings'
export const faqPagePath = '/faq'
export const profilePagePath = 'https://eboa.toya.net.pl/auth/login'
export const eboaDashboardUrl = 'https://eboa.toya.net.pl/dashboard/'
export const toyaTelewizjaUrl = 'https://toya.net.pl/telewizja'
export const termsOfServicePagePath = '/terms-of-service'
export const TCPage = '/termsAndConditions'
export const newsletterCancelPath = '/newsletter/cancel'
export const webPath = '/web'

//day times in milis
export const morningTimeStartHour = 6 * 60 * 60 * 1000
export const afternoonTimeStartHour = 13 * 60 * 60 * 1000
export const eveningTimeStartHour = 18 * 60 * 60 * 1000

// inputs type
export const inputPassword = 'password'

// other paths
export const emptyPath = '/'

// logo placeholders
export const loginScreenLogoUrlPlaceholder =
    'https://storage.googleapis.com/toya-334417.appspot.com/static/f72e63da3ac6bbadd2bbfb49cfec/login_screen_logo.png'
export const menuLogoUrlPlaceholder =
    'https://storage.googleapis.com/toya-334417.appspot.com/static/f72e63da3ac6bbadd2bbfb49cfec/menu_logo.png'

// login
export const minUserNameLength = 3
export const maxUserNameLength = 20

export const minPasswordLength = 5
export const maxPasswordLength = 25

// Profiles
export const defaultProfile = {
    iconId: '',
    default: true,
    id: '1',
    isKid: false,
    order: 'lcn',
    profile_name: 'User',
    version: 1,
}
export const MAX_PROFILES_LIMIT = 5
export const MAX_PIN_LENGTH = 4
export const MAX_DEVICE_ALIAS = 128

// Analytics
export const defaultAnalyticsConsent = <ConsentSettings>{
    ad_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    security_storage: 'denied',
    analytics_storage: 'denied',
}
export const grantedAnalyticsConsent = <ConsentSettings>{
    ad_storage: 'granted',
    analytics_storage: 'granted',
}

export const refreshInterval = 50 * 60 * 1000

export const TOP_MENU_HEIGHT = 100

export const IS_COOKIES_ACCEPTED = 'cookiesAccepted'
export const LAST_TIME_CACHE_CLEARED = 'Cache cleared at:'
export const APP_VERSION = 'App version is:'

// Defaults
export const defaultBackgroundAtmosferic =
    'https://data-go.toya.net.pl/atv/background_eboa_darkgrey.png'
